module.exports = __webpack_public_path__ + "media/images/flags/32/Brunei-3dbadae7bd096552f87e235c398d8607.png";